module.exports = __webpack_public_path__ + "img/arrow_lingua.78e2b523.svg";